import axios from "axios"
import api from "../api"
import {
  ON_SAVE_FAILED_REQUEST_SUCCESS,
  ON_SAVE_FAILED_REQUEST_FAIL,
} from "./types"

export const isNetworkError = (err) => {
  if (err.response) return false

  const networkErrorCodes = [
    "ECONNABORTED", // timeout
    "ECONNRESET", // connection dropped
    "ECONNREFUSED", // server refused connection
    "ENOTFOUND", // DNS lookup failed
    "EAI_AGAIN", // DNS temp failure
    "ERR_NETWORK", // Axios v1 generic network error
  ]

  const networkErrorMessages = ["Network Error", "Failed to fetch"]

  return (
    networkErrorCodes.includes(err.code) ||
    networkErrorMessages.some((m) => err.message?.includes(m))
  )
}

export const saveFailedRequest = ({
  url,
  queryParams,
  method,
  payload,
  errorCode,
  errorMessage,
}) => {
  return (dispatch, getState) => {
    const userId = getState().userLogin.userId
    const stationId = getState().bgService.stationId

    const requestData = {
      url,
      queryParams,
      method,
      payload: JSON.stringify(payload),
      errorCode,
      errorMessage,
      userId,
      stationId,
    }
    axios
      .post(api.saveFailedRequest, requestData)
      .then(() => {
        dispatch({ type: ON_SAVE_FAILED_REQUEST_SUCCESS })
      })
      .catch((e) => {
        console.error("Could not save failed request", e)
        dispatch({ type: ON_SAVE_FAILED_REQUEST_FAIL, payload: e })
      })
  }
}
